import { forwardRef } from "react";
import classNames from "classnames";
import type { ButtonProps } from "../Button/Button";
import Button from "../Button/Button";
import type { IconComponentType, IconSize } from "../Icon/Icon";
import styles from "./IconButton.module.scss";
import Tooltip from "../Tooltip/Tooltip";

const IconButton = forwardRef<
  HTMLButtonElement,
  {
    "aria-label": string;
    showTooltip?: boolean;
    IconComponent: IconComponentType;
    iconSize?: IconSize;
    hover?: "primary" | "gray";
  } & ButtonProps
>(function IconButton(
  {
    "aria-label": ariaLabel,
    showTooltip = true,
    iconSize = "medium",
    className,
    IconComponent,
    hover = "gray",
    size,
    variant = "gray",
    ...buttonProps
  },
  ref,
) {
  if (showTooltip) {
    return (
      <Tooltip content={ariaLabel}>
        <Button
          ref={ref}
          {...buttonProps}
          aria-label={ariaLabel}
          size={size}
          className={classNames(styles.button, styles[hover], className)}
          variant={variant}
          flat
        >
          <IconComponent size={iconSize} />
        </Button>
      </Tooltip>
    );
  }

  return (
    <Button
      ref={ref}
      {...buttonProps}
      aria-label={ariaLabel}
      className={classNames(styles.button, styles[hover], className)}
      size={size}
      variant="gray"
      flat
    >
      <IconComponent size={iconSize} />
    </Button>
  );
});

export default IconButton;
